export const styles = {
  button: {
    position: 'absolute',
    top: [6, 6, 6, 6, 25, 25],
    right: [6, 6, 40, 40, 40, 40],
    width: [28, 28, 40, 40, 'auto', 'auto'],
    height: [28, 28, 40, 40, 'auto', 'auto'],

    borderRadius: [40, 40, 40, 40, 'button', 'button'],
    py: [0, 0, 0, 0, 4, 4],
    zIndex: 1401
  },
  label: {
    color: 'textAlternate'
  },
  text: {
    display: ['none', 'none', 'none', 'none', 'none', 'none']
  }
}
export default styles
